import * as React from "react";
import { useIntl } from "@grandvisionhq/state";
import StorePaymentMethods from "./StorePaymentMethods.js";
const StorePaymentMethodsContainer = ({ logos, paymentMethods, ...rest }) => {
  const { getLabel } = useIntl();
  const labels = React.useMemo(
    () => ({
      title: getLabel("stores.page.details.paymentMethods.title")
    }),
    [getLabel]
  );
  const items = React.useMemo(
    () => paymentMethods.map(({ code }) => {
      const logo = logos?.find(({ key }) => key === code);
      if (!logo) {
        return null;
      }
      return {
        name: logo.displayName,
        iconUrl: logo.logo?.url
      };
    }).filter((item) => item !== null),
    [paymentMethods, logos]
  );
  return items.length > 0 ? /* @__PURE__ */ React.createElement(StorePaymentMethods, { ...rest, labels, items }) : null;
};
export {
  StorePaymentMethodsContainer as default
};
//# sourceMappingURL=StorePaymentMethodsContainer.js.map
